namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem4Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem4';
    }
}
